export const GET_LANGUAGES_WATCHER = 'GET_LANGUAGES_WATCHER';
export const GET_LANGUAGES_SUCCESS = 'GET_LANGUAGES_SUCCESS';
export const GET_LANGUAGES_FAILED = 'GET_LANGUAGES_FAILED';
